import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function WarningRoundedFill({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" fillRule="evenodd" clipRule="evenodd" d="M21.9751 12C21.9751 17.5191 17.5089 21.975 12.0001 21.975C6.49062 21.975 2.0251 17.5095 2.0251 12C2.0251 6.4905 6.49062 2.02498 12.0001 2.02498C17.5192 2.02498 21.9751 6.49113 21.9751 12ZM12.0103 16.9L12.0153 16.9L12.0203 16.9C12.045 16.9 12.0695 16.899 12.0937 16.897C12.6915 16.8545 13.1603 16.359 13.1603 15.75C13.1603 15.1463 12.6704 14.6 12.0103 14.6C11.6691 14.6 11.3867 14.7533 11.2001 14.9398C11.0136 15.1264 10.8603 15.4088 10.8603 15.75C10.8603 16.3934 11.3666 16.8459 11.9196 16.8955C11.9494 16.8984 11.9796 16.9 12.0103 16.9ZM11.1003 12C11.1003 12.497 11.5032 12.9 12.0003 12.9C12.4973 12.9 12.9003 12.497 12.9003 12L12.9003 6.99997C12.9003 6.50291 12.4973 6.09997 12.0003 6.09997C11.5032 6.09997 11.1003 6.50291 11.1003 6.99997L11.1003 12Z" fill="currentColor" /></Svg>;
}
export default WarningRoundedFill;